export default "__VITE_ASSET__CrBWl7Ob__"